// AUTO-GENERATED by scripts/sync_topics.mjs — do not edit by hand.
// Source of truth: question_gen_gem/blueprints/*.json L1 "subspecialty" nodes.
// Regenerate with `node scripts/sync_topics.mjs`; CI enforces `--check`.
//
// The controlled topic vocabulary. A question's `topics[]` and a user's
// `topicInterests[]` must both use these exact strings — the feed intersects
// them, so any drift silently zeroes the topic axis. Mirrors the EXAMS/ExamName
// idiom in exam.ts.

export const TOPICS = [
  'Abdominal Imaging',
  'Abnormal Labor and Operative Delivery',
  'Acid-Base Disorders',
  'Acute Kidney Injury',
  'Acute Leukemias',
  'Acute Respiratory Failure and ARDS',
  'Addiction Psychiatry',
  'Adolescent Medicine',
  'Adrenal Disorders',
  'Adult Congenital Heart Disease',
  'Ambulatory Anesthesiology',
  'Anorectal and Pelvic Floor Disorders',
  'Antimicrobial Stewardship and Pharmacology',
  'Anxiety, Obsessive-Compulsive, and Trauma-Related Disorders',
  'Aortic and Peripheral Vascular Diseases',
  'Autoimmune Connective Tissue Diseases',
  'Autoinflammatory Syndromes',
  'Autonomic Nervous System Disorders',
  'Bariatric and Metabolic Surgery',
  'Basic Neuroscience',
  'Behavioral Neurology and Dementia',
  'Benign Leukocyte Disorders',
  'Benign Pelvic Masses and Adnexal Pathology',
  'Biliary Tract Diseases',
  'Bone Marrow Failure Syndromes',
  'Bone and Mineral Metabolism',
  'Bone and Soft Tissue Pathology',
  'Bone and Soft Tissue Sarcoma',
  'Breast Imaging',
  'Breast Oncology',
  'Breast Pathology',
  'Breast Surgery',
  'Cardiac Arrhythmias and Electrophysiology',
  'Cardiac Radiology',
  'Cardio-Oncology',
  'Cardiomyopathies',
  'Cardiothoracic Anesthesiology',
  'Cardiovascular Emergencies',
  'Cardiovascular Imaging',
  'Cardiovascular Infections',
  'Cataract and Anterior Segment Surgery',
  'Central Nervous System Infections',
  'Cerebrovascular Disease and Stroke',
  'Cervical Dysplasia and Lower Genital Tract Disease',
  'Child Abuse Pediatrics',
  'Child and Adolescent Psychiatry',
  'Chronic Kidney Disease',
  'Chronic Leukemias',
  'Chronic Pain Medicine',
  'Cirrhosis and Complications of Portal Hypertension',
  'Clinical Chemistry',
  'Colorectal Surgery',
  'Consultation-Liaison Psychiatry',
  'Contact Dermatitis',
  'Cornea and External Disease',
  'Cosmetic Dermatology',
  'Critical Care Medicine',
  'Crystal-Induced Arthropathies',
  'Cutaneous Infections',
  'Cutaneous Oncology',
  'Cystic Fibrosis and Bronchiectasis',
  'Cytopathology',
  'Dermatologic Surgery',
  'Dermatopathology',
  'Developmental-Behavioral Pediatrics',
  'Diabetes Mellitus',
  'Early Pregnancy Complications',
  'Eating Disorders',
  'Emergency Psychiatry',
  'Emergency Radiology',
  'Endocrine Oncology',
  'Endocrine Surgery',
  'Endocrine and Metabolic Emergencies',
  'Endometriosis and Chronic Pelvic Pain',
  'Environmental Emergencies',
  'Epidemiology and Biostatistics',
  'Epilepsy and Seizure Disorders',
  'Esophageal Disorders',
  'Facial Plastic and Reconstructive Surgery',
  'Family Planning and Contraception',
  'Female Pelvic Floor Disorders and Urogynecology',
  'Fetal Anomalies and Genetic Screening',
  'Fetal Growth Restriction and Macrosomia',
  'Fluid and Electrolyte Disorders',
  'Foregut and Upper Gastrointestinal Surgery',
  'Forensic Pathology',
  'Forensic Psychiatry',
  'Gastroduodenal Disorders and Peptic Ulcer Disease',
  'Gastrointestinal Bleeding',
  'Gastrointestinal Emergencies',
  'Gastrointestinal Oncology',
  'Gastrointestinal and Hepatobiliary Malignancies',
  'Gastrointestinal and Liver Pathology',
  'General Pathology',
  'Genetic and Cystic Kidney Diseases',
  'Genitourinary Oncology',
  'Genitourinary Pathology',
  'Genitourinary Radiology',
  'Genitourinary and Sexually Transmitted Infections',
  'Genodermatoses',
  'Geriatric Psychiatry',
  'Gestational and Pre-gestational Diabetes',
  'Glaucoma',
  'Glomerular Diseases',
  'Gross Anatomy',
  'Gynecologic Infectious Diseases',
  'Gynecologic Oncology',
  'Gynecologic Pathology',
  'HEENT Emergencies',
  'HIV and AIDS',
  'Hair and Nail Disorders',
  'Head and Neck Oncology',
  'Head and Neck Radiology',
  'Head and Neck Surgical Oncology',
  'Headache and Pain Medicine',
  'Healthcare-Associated Infections and Infection Control',
  'Heart Failure and Transplant Cardiology',
  'Hematologic Malignancies',
  'Hematologic and Oncologic Emergencies',
  'Hematopathology',
  'Hematopoietic Stem Cell Transplantation and Cellular Therapy',
  'Hemoglobinopathies',
  'Hemolytic Anemias',
  'Hemostasis and Bleeding Disorders',
  'Hepatopancreatobiliary (HPB) Surgery',
  'Hernia and Abdominal Wall Surgery',
  'Histology and Cell Biology',
  'Hypertension',
  'Hypertensive Disorders of Pregnancy',
  'Idiopathic Inflammatory Myopathies',
  'Infections in the Immunocompromised Host',
  'Infectious Arthritis',
  'Infectious Disease Emergencies',
  'Infectious Diseases in Pregnancy',
  'Inflammatory Bowel Disease',
  'Interstitial Lung Diseases',
  'Interventional Pulmonology',
  'Interventional and Therapeutic Endoscopy',
  'Intra-abdominal and Gastrointestinal Infections',
  'Invasive Fungal Infections',
  'Ischemic Heart Disease and Acute Coronary Syndromes',
  'Kidney Transplantation',
  'Laryngology and Voice Disorders',
  'Lipid Disorders',
  'Lung Transplantation',
  'Lymphomas',
  'Malabsorption and Small Bowel Disorders',
  'Maternal-Fetal Physiology',
  'Medical Biochemistry',
  'Medical Embryology',
  'Medical Genetics',
  'Medical Immunology',
  'Medical Microbiology',
  'Medical Pharmacology',
  'Medical Physiology',
  'Medical Toxicology',
  'Melanoma and Cutaneous Oncology',
  'Menopause and Climacteric Medicine',
  'Menstrual Disorders and Abnormal Uterine Bleeding',
  'Metabolic Bone Diseases',
  'Molecular Genetic Pathology',
  'Mood Disorders',
  'Movement Disorders',
  'Multiple Gestations',
  'Musculoskeletal Radiology',
  'Mycobacterial Infections',
  'Myelodysplastic Syndromes',
  'Myeloproliferative Neoplasms',
  'Neonatal-Perinatal Medicine',
  'Nephrolithiasis',
  'Neuro-Oncology',
  'Neuro-Ophthalmology',
  'Neuro-ophthalmology and Neuro-otology',
  'Neuroanesthesiology',
  'Neurocognitive Disorders',
  'Neurocritical Care',
  'Neurogastroenterology and Motility Disorders',
  'Neuroimmunology and Demyelinating Diseases',
  'Neuroinfectious Diseases',
  'Neurologic Emergencies',
  'Neuromuscular Disorders',
  'Neuropathology',
  'Neuroradiology',
  'Normal Labor and Vaginal Delivery',
  'Nuclear Medicine',
  'Nutritional and Hypoproliferative Anemias',
  'Obesity and Metabolic Medicine',
  'Obstetric Anesthesiology',
  'Obstetric Nephrology',
  'Obstetric and Gynecologic Emergencies',
  'Obstructive Lung Diseases',
  'Occupational and Environmental Lung Diseases',
  'Ocular Oncology',
  'Onco-Nephrology',
  'Ophthalmic Pathology',
  'Ophthalmic Plastic and Reconstructive Surgery',
  'Osteoarthritis',
  'Otolaryngic Allergy',
  'Otology and Neurotology',
  'Palliative Oncology and Survivorship',
  'Pancreatic Diseases',
  'Papulosquamous and Eczematous Dermatoses',
  'Parasitic and Zoonotic Infections',
  'Pediatric Anesthesiology',
  'Pediatric Cardiology',
  'Pediatric Critical Care Medicine',
  'Pediatric Dermatology',
  'Pediatric Emergency Medicine',
  'Pediatric Endocrinology',
  'Pediatric Gastroenterology',
  'Pediatric Hematology and Oncology',
  'Pediatric Infectious Diseases',
  'Pediatric Nephrology',
  'Pediatric Neurology',
  'Pediatric Oncology',
  'Pediatric Ophthalmology and Strabismus',
  'Pediatric Otolaryngology',
  'Pediatric Pathology',
  'Pediatric Pulmonology',
  'Pediatric Radiology',
  'Pediatric Rheumatology',
  'Pediatric Surgery',
  'Pediatric and Adolescent Gynecology',
  'Pericardial Diseases',
  'Perioperative Medicine',
  'Personality Disorders',
  'Photodermatology',
  'Pigmentary Disorders',
  'Pituitary Disorders',
  'Placental Disorders and Antepartum Hemorrhage',
  'Plasma Cell Dyscrasias',
  'Pleural Diseases',
  'Postpartum Hemorrhage',
  'Preterm Labor and Birth',
  'Preventive Cardiology and Lipidology',
  'Psychiatric and Behavioral Emergencies',
  'Puerperal Infections and Postpartum Care',
  'Pulmonary Infections',
  'Pulmonary Vascular Disease and Right Heart Failure',
  'Pulmonary Vascular Diseases',
  'Refractive Surgery',
  'Regional Anesthesiology and Acute Pain Medicine',
  'Regional Musculoskeletal Disorders and Fibromyalgia',
  'Renal Replacement Therapy',
  'Renal and Genitourinary Emergencies',
  'Reproductive Endocrinology',
  'Reproductive Endocrinology and Infertility',
  'Reproductive and Perinatal Psychiatry',
  'Respiratory Emergencies',
  'Respiratory Tract Infections',
  'Rheumatoid Arthritis',
  'Rhinology and Paranasal Sinus Diseases',
  'Routine Antenatal Care',
  'Salivary Gland Disorders',
  'Schizophrenia and Psychotic Disorders',
  "Sjögren's Syndrome",
  'Skin, Soft Tissue, and Bone Infections',
  'Skull Base Surgery',
  'Sleep Disorders',
  'Sleep Medicine and Surgery',
  'Sleep-Related Breathing Disorders',
  'Sleep-Wake Disorders',
  'Spondyloarthritis',
  'Surgical Critical Care',
  'Surgical Oncology',
  'Swallowing and Dysphagia',
  'Systemic Lupus Erythematosus and Antiphospholipid Syndrome',
  'Systemic Sclerosis and Related Disorders',
  'Systemic Vasculitis',
  'Thoracic Oncology',
  'Thoracic Radiology',
  'Thrombosis and Thrombophilia',
  'Thyroid Disorders',
  'Thyroid and Parathyroid Surgery',
  'Transfusion Medicine',
  'Transplant Anesthesiology',
  'Transplant Surgery',
  'Trauma Anesthesiology',
  'Trauma and Acute Care Surgery',
  'Trauma and Orthopedic Emergencies',
  'Travel, Tropical, and Emerging Infections',
  'Tubulointerstitial Diseases',
  'Uveitis and Ocular Immunology',
  'Valvular Heart Disease',
  'Vascular Surgery',
  'Vascular and Interventional Radiology',
  'Vesiculobullous Diseases',
  'Viral, Autoimmune, and Metabolic Liver Diseases',
  'Vitreoretinal Diseases',
  'Vulvar Dermatoses and Benign Vulvovaginal Disorders',
] as const;

export type TopicName = (typeof TOPICS)[number];

// Each topic's owning specialty: the blueprint(s) that declare it as an L1 node.
// The generator stamps `topics` from the blueprint and never re-tags it, while
// the tagger may re-label `specialty`, so this map — not a question's
// `specialty` — says where a topic belongs. The quiz builder groups by it.
// A topic declared by two blueprints lists both.
export const TOPIC_SPECIALTIES: Readonly<Record<TopicName, readonly string[]>> = {
  'Abdominal Imaging': ['Radiology'],
  'Abnormal Labor and Operative Delivery': ['Obstetrics & Gynecology'],
  'Acid-Base Disorders': ['Nephrology'],
  'Acute Kidney Injury': ['Nephrology'],
  'Acute Leukemias': ['Hematology'],
  'Acute Respiratory Failure and ARDS': ['Pulmonology'],
  'Addiction Psychiatry': ['Psychiatry'],
  'Adolescent Medicine': ['Pediatrics'],
  'Adrenal Disorders': ['Endocrinology'],
  'Adult Congenital Heart Disease': ['Cardiology'],
  'Ambulatory Anesthesiology': ['Anesthesiology'],
  'Anorectal and Pelvic Floor Disorders': ['Gastroenterology'],
  'Antimicrobial Stewardship and Pharmacology': ['Infectious Disease'],
  'Anxiety, Obsessive-Compulsive, and Trauma-Related Disorders': ['Psychiatry'],
  'Aortic and Peripheral Vascular Diseases': ['Cardiology'],
  'Autoimmune Connective Tissue Diseases': ['Dermatology'],
  'Autoinflammatory Syndromes': ['Rheumatology'],
  'Autonomic Nervous System Disorders': ['Neurology'],
  'Bariatric and Metabolic Surgery': ['General Surgery'],
  'Basic Neuroscience': ['Basic Medical Sciences'],
  'Behavioral Neurology and Dementia': ['Neurology'],
  'Benign Leukocyte Disorders': ['Hematology'],
  'Benign Pelvic Masses and Adnexal Pathology': ['Obstetrics & Gynecology'],
  'Biliary Tract Diseases': ['Gastroenterology'],
  'Bone Marrow Failure Syndromes': ['Hematology'],
  'Bone and Mineral Metabolism': ['Endocrinology'],
  'Bone and Soft Tissue Pathology': ['Pathology'],
  'Bone and Soft Tissue Sarcoma': ['Oncology'],
  'Breast Imaging': ['Radiology'],
  'Breast Oncology': ['Oncology'],
  'Breast Pathology': ['Pathology'],
  'Breast Surgery': ['General Surgery'],
  'Cardiac Arrhythmias and Electrophysiology': ['Cardiology'],
  'Cardiac Radiology': ['Radiology'],
  'Cardio-Oncology': ['Cardiology'],
  Cardiomyopathies: ['Cardiology'],
  'Cardiothoracic Anesthesiology': ['Anesthesiology'],
  'Cardiovascular Emergencies': ['Emergency Medicine'],
  'Cardiovascular Imaging': ['Cardiology'],
  'Cardiovascular Infections': ['Infectious Disease'],
  'Cataract and Anterior Segment Surgery': ['Ophthalmology'],
  'Central Nervous System Infections': ['Infectious Disease'],
  'Cerebrovascular Disease and Stroke': ['Neurology'],
  'Cervical Dysplasia and Lower Genital Tract Disease': ['Obstetrics & Gynecology'],
  'Child Abuse Pediatrics': ['Pediatrics'],
  'Child and Adolescent Psychiatry': ['Psychiatry'],
  'Chronic Kidney Disease': ['Nephrology'],
  'Chronic Leukemias': ['Hematology'],
  'Chronic Pain Medicine': ['Anesthesiology'],
  'Cirrhosis and Complications of Portal Hypertension': ['Gastroenterology'],
  'Clinical Chemistry': ['Pathology'],
  'Colorectal Surgery': ['General Surgery'],
  'Consultation-Liaison Psychiatry': ['Psychiatry'],
  'Contact Dermatitis': ['Dermatology'],
  'Cornea and External Disease': ['Ophthalmology'],
  'Cosmetic Dermatology': ['Dermatology'],
  'Critical Care Medicine': ['Anesthesiology'],
  'Crystal-Induced Arthropathies': ['Rheumatology'],
  'Cutaneous Infections': ['Dermatology'],
  'Cutaneous Oncology': ['Dermatology'],
  'Cystic Fibrosis and Bronchiectasis': ['Pulmonology'],
  Cytopathology: ['Pathology'],
  'Dermatologic Surgery': ['Dermatology'],
  Dermatopathology: ['Dermatology', 'Pathology'],
  'Developmental-Behavioral Pediatrics': ['Pediatrics'],
  'Diabetes Mellitus': ['Endocrinology'],
  'Early Pregnancy Complications': ['Obstetrics & Gynecology'],
  'Eating Disorders': ['Psychiatry'],
  'Emergency Psychiatry': ['Psychiatry'],
  'Emergency Radiology': ['Radiology'],
  'Endocrine Oncology': ['Endocrinology'],
  'Endocrine Surgery': ['General Surgery'],
  'Endocrine and Metabolic Emergencies': ['Emergency Medicine'],
  'Endometriosis and Chronic Pelvic Pain': ['Obstetrics & Gynecology'],
  'Environmental Emergencies': ['Emergency Medicine'],
  'Epidemiology and Biostatistics': ['Basic Medical Sciences'],
  'Epilepsy and Seizure Disorders': ['Neurology'],
  'Esophageal Disorders': ['Gastroenterology'],
  'Facial Plastic and Reconstructive Surgery': ['Otolaryngology'],
  'Family Planning and Contraception': ['Obstetrics & Gynecology'],
  'Female Pelvic Floor Disorders and Urogynecology': ['Obstetrics & Gynecology'],
  'Fetal Anomalies and Genetic Screening': ['Obstetrics & Gynecology'],
  'Fetal Growth Restriction and Macrosomia': ['Obstetrics & Gynecology'],
  'Fluid and Electrolyte Disorders': ['Nephrology'],
  'Foregut and Upper Gastrointestinal Surgery': ['General Surgery'],
  'Forensic Pathology': ['Pathology'],
  'Forensic Psychiatry': ['Psychiatry'],
  'Gastroduodenal Disorders and Peptic Ulcer Disease': ['Gastroenterology'],
  'Gastrointestinal Bleeding': ['Gastroenterology'],
  'Gastrointestinal Emergencies': ['Emergency Medicine'],
  'Gastrointestinal Oncology': ['Oncology'],
  'Gastrointestinal and Hepatobiliary Malignancies': ['Gastroenterology'],
  'Gastrointestinal and Liver Pathology': ['Pathology'],
  'General Pathology': ['Basic Medical Sciences'],
  'Genetic and Cystic Kidney Diseases': ['Nephrology'],
  'Genitourinary Oncology': ['Oncology'],
  'Genitourinary Pathology': ['Pathology'],
  'Genitourinary Radiology': ['Radiology'],
  'Genitourinary and Sexually Transmitted Infections': ['Infectious Disease'],
  Genodermatoses: ['Dermatology'],
  'Geriatric Psychiatry': ['Psychiatry'],
  'Gestational and Pre-gestational Diabetes': ['Obstetrics & Gynecology'],
  Glaucoma: ['Ophthalmology'],
  'Glomerular Diseases': ['Nephrology'],
  'Gross Anatomy': ['Basic Medical Sciences'],
  'Gynecologic Infectious Diseases': ['Obstetrics & Gynecology'],
  'Gynecologic Oncology': ['Obstetrics & Gynecology', 'Oncology'],
  'Gynecologic Pathology': ['Pathology'],
  'HEENT Emergencies': ['Emergency Medicine'],
  'HIV and AIDS': ['Infectious Disease'],
  'Hair and Nail Disorders': ['Dermatology'],
  'Head and Neck Oncology': ['Oncology'],
  'Head and Neck Radiology': ['Radiology'],
  'Head and Neck Surgical Oncology': ['Otolaryngology'],
  'Headache and Pain Medicine': ['Neurology'],
  'Healthcare-Associated Infections and Infection Control': ['Infectious Disease'],
  'Heart Failure and Transplant Cardiology': ['Cardiology'],
  'Hematologic Malignancies': ['Oncology'],
  'Hematologic and Oncologic Emergencies': ['Emergency Medicine'],
  Hematopathology: ['Pathology'],
  'Hematopoietic Stem Cell Transplantation and Cellular Therapy': ['Hematology'],
  Hemoglobinopathies: ['Hematology'],
  'Hemolytic Anemias': ['Hematology'],
  'Hemostasis and Bleeding Disorders': ['Hematology'],
  'Hepatopancreatobiliary (HPB) Surgery': ['General Surgery'],
  'Hernia and Abdominal Wall Surgery': ['General Surgery'],
  'Histology and Cell Biology': ['Basic Medical Sciences'],
  Hypertension: ['Nephrology'],
  'Hypertensive Disorders of Pregnancy': ['Obstetrics & Gynecology'],
  'Idiopathic Inflammatory Myopathies': ['Rheumatology'],
  'Infections in the Immunocompromised Host': ['Infectious Disease'],
  'Infectious Arthritis': ['Rheumatology'],
  'Infectious Disease Emergencies': ['Emergency Medicine'],
  'Infectious Diseases in Pregnancy': ['Obstetrics & Gynecology'],
  'Inflammatory Bowel Disease': ['Gastroenterology'],
  'Interstitial Lung Diseases': ['Pulmonology'],
  'Interventional Pulmonology': ['Pulmonology'],
  'Interventional and Therapeutic Endoscopy': ['Gastroenterology'],
  'Intra-abdominal and Gastrointestinal Infections': ['Infectious Disease'],
  'Invasive Fungal Infections': ['Infectious Disease'],
  'Ischemic Heart Disease and Acute Coronary Syndromes': ['Cardiology'],
  'Kidney Transplantation': ['Nephrology'],
  'Laryngology and Voice Disorders': ['Otolaryngology'],
  'Lipid Disorders': ['Endocrinology'],
  'Lung Transplantation': ['Pulmonology'],
  Lymphomas: ['Hematology'],
  'Malabsorption and Small Bowel Disorders': ['Gastroenterology'],
  'Maternal-Fetal Physiology': ['Obstetrics & Gynecology'],
  'Medical Biochemistry': ['Basic Medical Sciences'],
  'Medical Embryology': ['Basic Medical Sciences'],
  'Medical Genetics': ['Basic Medical Sciences'],
  'Medical Immunology': ['Basic Medical Sciences'],
  'Medical Microbiology': ['Basic Medical Sciences', 'Pathology'],
  'Medical Pharmacology': ['Basic Medical Sciences'],
  'Medical Physiology': ['Basic Medical Sciences'],
  'Medical Toxicology': ['Emergency Medicine'],
  'Melanoma and Cutaneous Oncology': ['Oncology'],
  'Menopause and Climacteric Medicine': ['Obstetrics & Gynecology'],
  'Menstrual Disorders and Abnormal Uterine Bleeding': ['Obstetrics & Gynecology'],
  'Metabolic Bone Diseases': ['Rheumatology'],
  'Molecular Genetic Pathology': ['Pathology'],
  'Mood Disorders': ['Psychiatry'],
  'Movement Disorders': ['Neurology'],
  'Multiple Gestations': ['Obstetrics & Gynecology'],
  'Musculoskeletal Radiology': ['Radiology'],
  'Mycobacterial Infections': ['Infectious Disease'],
  'Myelodysplastic Syndromes': ['Hematology'],
  'Myeloproliferative Neoplasms': ['Hematology'],
  'Neonatal-Perinatal Medicine': ['Pediatrics'],
  Nephrolithiasis: ['Nephrology'],
  'Neuro-Oncology': ['Neurology', 'Oncology'],
  'Neuro-Ophthalmology': ['Ophthalmology'],
  'Neuro-ophthalmology and Neuro-otology': ['Neurology'],
  Neuroanesthesiology: ['Anesthesiology'],
  'Neurocognitive Disorders': ['Psychiatry'],
  'Neurocritical Care': ['Neurology'],
  'Neurogastroenterology and Motility Disorders': ['Gastroenterology'],
  'Neuroimmunology and Demyelinating Diseases': ['Neurology'],
  'Neuroinfectious Diseases': ['Neurology'],
  'Neurologic Emergencies': ['Emergency Medicine'],
  'Neuromuscular Disorders': ['Neurology'],
  Neuropathology: ['Pathology'],
  Neuroradiology: ['Radiology'],
  'Normal Labor and Vaginal Delivery': ['Obstetrics & Gynecology'],
  'Nuclear Medicine': ['Radiology'],
  'Nutritional and Hypoproliferative Anemias': ['Hematology'],
  'Obesity and Metabolic Medicine': ['Endocrinology'],
  'Obstetric Anesthesiology': ['Anesthesiology'],
  'Obstetric Nephrology': ['Nephrology'],
  'Obstetric and Gynecologic Emergencies': ['Emergency Medicine'],
  'Obstructive Lung Diseases': ['Pulmonology'],
  'Occupational and Environmental Lung Diseases': ['Pulmonology'],
  'Ocular Oncology': ['Ophthalmology'],
  'Onco-Nephrology': ['Nephrology'],
  'Ophthalmic Pathology': ['Ophthalmology'],
  'Ophthalmic Plastic and Reconstructive Surgery': ['Ophthalmology'],
  Osteoarthritis: ['Rheumatology'],
  'Otolaryngic Allergy': ['Otolaryngology'],
  'Otology and Neurotology': ['Otolaryngology'],
  'Palliative Oncology and Survivorship': ['Oncology'],
  'Pancreatic Diseases': ['Gastroenterology'],
  'Papulosquamous and Eczematous Dermatoses': ['Dermatology'],
  'Parasitic and Zoonotic Infections': ['Infectious Disease'],
  'Pediatric Anesthesiology': ['Anesthesiology'],
  'Pediatric Cardiology': ['Pediatrics'],
  'Pediatric Critical Care Medicine': ['Pediatrics'],
  'Pediatric Dermatology': ['Dermatology'],
  'Pediatric Emergency Medicine': ['Emergency Medicine', 'Pediatrics'],
  'Pediatric Endocrinology': ['Pediatrics'],
  'Pediatric Gastroenterology': ['Pediatrics'],
  'Pediatric Hematology and Oncology': ['Pediatrics'],
  'Pediatric Infectious Diseases': ['Pediatrics'],
  'Pediatric Nephrology': ['Pediatrics'],
  'Pediatric Neurology': ['Neurology', 'Pediatrics'],
  'Pediatric Oncology': ['Oncology'],
  'Pediatric Ophthalmology and Strabismus': ['Ophthalmology'],
  'Pediatric Otolaryngology': ['Otolaryngology'],
  'Pediatric Pathology': ['Pathology'],
  'Pediatric Pulmonology': ['Pediatrics'],
  'Pediatric Radiology': ['Radiology'],
  'Pediatric Rheumatology': ['Pediatrics', 'Rheumatology'],
  'Pediatric Surgery': ['General Surgery'],
  'Pediatric and Adolescent Gynecology': ['Obstetrics & Gynecology'],
  'Pericardial Diseases': ['Cardiology'],
  'Perioperative Medicine': ['Anesthesiology'],
  'Personality Disorders': ['Psychiatry'],
  Photodermatology: ['Dermatology'],
  'Pigmentary Disorders': ['Dermatology'],
  'Pituitary Disorders': ['Endocrinology'],
  'Placental Disorders and Antepartum Hemorrhage': ['Obstetrics & Gynecology'],
  'Plasma Cell Dyscrasias': ['Hematology'],
  'Pleural Diseases': ['Pulmonology'],
  'Postpartum Hemorrhage': ['Obstetrics & Gynecology'],
  'Preterm Labor and Birth': ['Obstetrics & Gynecology'],
  'Preventive Cardiology and Lipidology': ['Cardiology'],
  'Psychiatric and Behavioral Emergencies': ['Emergency Medicine'],
  'Puerperal Infections and Postpartum Care': ['Obstetrics & Gynecology'],
  'Pulmonary Infections': ['Pulmonology'],
  'Pulmonary Vascular Disease and Right Heart Failure': ['Cardiology'],
  'Pulmonary Vascular Diseases': ['Pulmonology'],
  'Refractive Surgery': ['Ophthalmology'],
  'Regional Anesthesiology and Acute Pain Medicine': ['Anesthesiology'],
  'Regional Musculoskeletal Disorders and Fibromyalgia': ['Rheumatology'],
  'Renal Replacement Therapy': ['Nephrology'],
  'Renal and Genitourinary Emergencies': ['Emergency Medicine'],
  'Reproductive Endocrinology': ['Endocrinology'],
  'Reproductive Endocrinology and Infertility': ['Obstetrics & Gynecology'],
  'Reproductive and Perinatal Psychiatry': ['Psychiatry'],
  'Respiratory Emergencies': ['Emergency Medicine'],
  'Respiratory Tract Infections': ['Infectious Disease'],
  'Rheumatoid Arthritis': ['Rheumatology'],
  'Rhinology and Paranasal Sinus Diseases': ['Otolaryngology'],
  'Routine Antenatal Care': ['Obstetrics & Gynecology'],
  'Salivary Gland Disorders': ['Otolaryngology'],
  'Schizophrenia and Psychotic Disorders': ['Psychiatry'],
  "Sjögren's Syndrome": ['Rheumatology'],
  'Skin, Soft Tissue, and Bone Infections': ['Infectious Disease'],
  'Skull Base Surgery': ['Otolaryngology'],
  'Sleep Disorders': ['Neurology'],
  'Sleep Medicine and Surgery': ['Otolaryngology'],
  'Sleep-Related Breathing Disorders': ['Pulmonology'],
  'Sleep-Wake Disorders': ['Psychiatry'],
  Spondyloarthritis: ['Rheumatology'],
  'Surgical Critical Care': ['General Surgery'],
  'Surgical Oncology': ['General Surgery'],
  'Swallowing and Dysphagia': ['Otolaryngology'],
  'Systemic Lupus Erythematosus and Antiphospholipid Syndrome': ['Rheumatology'],
  'Systemic Sclerosis and Related Disorders': ['Rheumatology'],
  'Systemic Vasculitis': ['Rheumatology'],
  'Thoracic Oncology': ['Oncology', 'Pulmonology'],
  'Thoracic Radiology': ['Radiology'],
  'Thrombosis and Thrombophilia': ['Hematology'],
  'Thyroid Disorders': ['Endocrinology'],
  'Thyroid and Parathyroid Surgery': ['Otolaryngology'],
  'Transfusion Medicine': ['Hematology', 'Pathology'],
  'Transplant Anesthesiology': ['Anesthesiology'],
  'Transplant Surgery': ['General Surgery'],
  'Trauma Anesthesiology': ['Anesthesiology'],
  'Trauma and Acute Care Surgery': ['General Surgery'],
  'Trauma and Orthopedic Emergencies': ['Emergency Medicine'],
  'Travel, Tropical, and Emerging Infections': ['Infectious Disease'],
  'Tubulointerstitial Diseases': ['Nephrology'],
  'Uveitis and Ocular Immunology': ['Ophthalmology'],
  'Valvular Heart Disease': ['Cardiology'],
  'Vascular Surgery': ['General Surgery'],
  'Vascular and Interventional Radiology': ['Radiology'],
  'Vesiculobullous Diseases': ['Dermatology'],
  'Viral, Autoimmune, and Metabolic Liver Diseases': ['Gastroenterology'],
  'Vitreoretinal Diseases': ['Ophthalmology'],
  'Vulvar Dermatoses and Benign Vulvovaginal Disorders': ['Obstetrics & Gynecology'],
};
